import React from "react"
import { BgImage } from "gbimage-bridge"
// import "../css/main.css"
import TopMenu from "./TopMenu"
import Testimonial from "../components/testimonials/Testimonial"
import BookDemo from "./BookDemo"
import Footer from "./Footer"
// import CookieConsent from "./cookie-consent/CookieConsent"


const LayoutGeneric = ({ children, title, subtitle, image:fluid, testimonial, noBook, bookDemo }) => {
  return (
    <div className="">
      <BgImage image={fluid} className="gs-bg-parallax"></BgImage>
      {/* <div className="gs-bg-parallax" style={{ backgroundImage: "url(" + fluid.src + ")" }}></div> */}
      <TopMenu/>
      <div className="gs-page">

        <div className="gs-bg-parallax__wrap">

          <div className="gs-page-hero">
            <div className="gs-page-hero__in gs-sect__in">
              <div className="gs-container">
                <header className="gs-page-header">
                    <h1 className="gs-page-header-title gs-header-msg--mark">{ title }</h1>
                    <div className="gs-products-item__hr"></div>
                    <h3 className="gs-page-header-subtitle fw300">{ subtitle }</h3>
                </header>
              </div>
            </div>
          </div>

        <section className="gs-prod-description gs-products-item">
          <div className="gs-sect__in gs-container ovh">
              <div className="gs-page-content">
              {children}
              </div>
          </div>
        </section>
        

        {
          !noBook && <div className="">
            <section className="gs-products-item gs-products-item--2">
              <div className="gs-sect__in gs-container ovh">
              <Testimonial selected={testimonial}></Testimonial>
              </div>
            </section>
            <BookDemo
              title={bookDemo && bookDemo.title}
              text={bookDemo && bookDemo.text}
              cta={bookDemo && bookDemo.buttonText}
            /> 
          </div>
        }

        { 
          noBook && <div className="gs-sect__in gs-container ovh">
            <Testimonial selected={testimonial}></Testimonial>
            
          </div>
        }
        
        <Footer />
        {/* <CookieConsent></CookieConsent> */}
        </div>
        </div>
      </div>
  )
}

export default LayoutGeneric
